import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setEditable } from "../../../store/actions/index";
import axiosInstance from "../../../store/services/AxiosService";

class TableListCase extends Component {
	constructor(props) {
		super(props);
		this._isMounted = false;
		this.state = {
			alertDelete: null,
			alertSuccess: null,
			duplicating: null,
		};
	}

	componentDidMount() {
		this._isMounted = true;
		if (this._isMounted) {
			const script = document.createElement("script");
			script.src = "assets/js/dataTable-content.js";
			script.async = true;
			document.body.appendChild(script);
		}
	}

	changeDateFormat = (date) => {
		let dateNew = moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
		return dateNew;
	};

	componentWillUnmount() {
		this._isMounted = false;
	}

	handleDuplicate = (caseId) => {
		this.setState({ duplicating: caseId });
		axiosInstance
			.post(`/cases/duplicate/${caseId}`)
			.then(() => {
				window.location.reload();
			})
			.catch((error) => {
				alert("Gagal menduplikasi soal: " + error.message);
				this.setState({ duplicating: null });
			});
	};

	handleExport = (caseId, caseName) => {
		const fileName = `Soal_${caseName.replace(/[^a-zA-Z0-9_\-]/g, '_')}.docx`;
		
		axiosInstance.get(`/cases/export/${caseId}`, { responseType: 'blob' })
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				link.parentNode.removeChild(link);
			})
			.catch((error) => {
				alert("Gagal mengexport soal: " + error.message);
			});
	};

	render() {
		return (
			<div style={{ overflowX: "auto" }}>
				<table className="table table-bordered text-center responsive nowrap table-hover" id="dataTable_ListCase" style={{ width: "100%" }}>
					<thead>
						<tr>
							<th>Mata Pelajaran</th>
							<th>Nama Soal</th>
							<th>Kelas</th>
							<th style={{ width: "8rem" }}>Terakhir diubah</th>
							<th style={{ width: "5rem" }}>Soal</th>
							<th style={{ width: "9rem" }}>Status</th>
							<th style={{ minWidth: "7rem" }}>Aksi</th>
						</tr>
					</thead>
					<tbody>
						{Object.values(this.props.listSoal).map((member) => (
							<tr key={member.id}>
								<td style={{ overflow: "hidden", maxWidth: "24vw", textOverflow: "ellipsis" }}>
									<b>{member.course_name}</b>
								</td>
								<td style={{ overflow: "hidden", maxWidth: "24vw", textOverflow: "ellipsis" }}>{member.name}</td>
								<td>{member.class_label || '-'}</td>
								<td style={{ width: "8rem" }}>{this.changeDateFormat(member.updated_at)}</td>
								<td style={{ width: "5rem" }}>{member.total_cases}</td>
								<td style={{ width: "9rem" }}>
									{member.editable === true ? (
										"Belum Digunakan"
									) : (
										<b>
											<i>Digunakan</i>
										</b>
									)}
								</td>
								<td className="p-2">
									<div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "stretch" }}>
										<Link to={`/edit-exam/${member.api_course_id}/${member.id}`}>
											<button className={`btn btn-sm btn-block ${member.editable ? 'btn-gradient-success' : 'btn-gradient-info'}`} onClick={() => this.props.setEditable(member.editable)}>
												{member.editable ? (
													<><i className="mdi mdi-tooltip-edit"></i> Ubah</>
												) : (
													<><i className="mdi mdi-eye"></i> Lihat</>
												)}
											</button>
										</Link>
										<button
											className="btn btn-sm btn-block btn-gradient-warning"
											disabled={this.state.duplicating === member.id}
											onClick={() => this.handleDuplicate(member.id)}
										>
											<i className="mdi mdi-content-copy"></i>
											{this.state.duplicating === member.id ? " ..." : " Duplikat"}
										</button>
										<button
											className="btn btn-sm btn-block btn-gradient-info"
											onClick={() => this.handleExport(member.id, member.name)}
										>
											<i className="mdi mdi-download"></i> Export
										</button>
										<button disabled={!member.editable} className="btn btn-sm btn-block btn-danger" onClick={() => this.props.onClickDeleteCase(member.id, member.editable)}>
											<i className="mdi mdi-delete"></i> Hapus
										</button>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		setEditable: (status) => dispatch(setEditable(status)),
	};
};

export default connect(null, mapDispatchToProps)(TableListCase);
